import React from 'react'
import styled from 'styled-components'
import { TogglePasswordButton } from './ToggleShowPasswordButton'
import { ReactComponent as CopyIcon } from '@sketch/icons/rectangles-2-17'
import { ReactComponent as RefreshIcon } from '@sketch/icons/arrow-counterclockwise-17'

const CopyButton = styled(TogglePasswordButton)`
  right: 48px;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  &:active {
    color: ${({ theme }) => theme.colors.sketch.A};
    background-color: ${({ theme }) => theme.colors.sketch.F};
    border-radius: 6px;
  }
`

const GenerateButton = styled(CopyButton)`
  right: 96px;
  top: 21px;
`

interface ToggleCopyPasswordButtonProps {
  onClick: () => void
  disabled?: boolean
}

export const ToggleCopyPasswordButton: React.FC<
  ToggleCopyPasswordButtonProps
> = ({ onClick, disabled = false }: ToggleCopyPasswordButtonProps) => {
  return (
    <CopyButton
      data-testid="copy-icon"
      onClick={onClick}
      disabled={disabled}
      showPassword={false}
    >
      <CopyIcon width={24} height={24} focusable={false} aria-hidden={true} />
    </CopyButton>
  )
}

export const ToggleGeneratePasswordButton: React.FC<
  ToggleCopyPasswordButtonProps
> = ({ onClick, disabled = false }: ToggleCopyPasswordButtonProps) => {
  return (
    <GenerateButton
      data-testid="refresh-icon"
      onClick={onClick}
      disabled={disabled}
      showPassword={false}
    >
      <RefreshIcon
        width={24}
        height={24}
        focusable={false}
        aria-hidden={true}
      />
    </GenerateButton>
  )
}
